// @ts-nocheck
import {
  ComponentInternalInstance,
  computed,
  defineComponent,
  getCurrentInstance,
  onMounted,
  ref,
} from 'vue-demi';
import i18n from './../../i18n';
import { isEmpty } from 'lodash';
import { error } from './state';
import { useState } from './hooks';
import TiktokPost from './tiktok-post/index.vue';
import { TTCallToAction } from './../../const/creative';
import { IdentityType } from './../../const/media';
import { CreativePreviewer } from './../../ttam-ui-bridge';
import { saveDraft } from './../globalActions';
import { InstantFormItem } from './../../const/leadAds';
import videoUpload from './video-upload/index-data.vue';
import adsCreative from './../../store/modules/ads_creative/index';
import PopupChosen from 'src/components/popup-chosen-new.vue';
import HeaderStepNew from 'src/components/header-step-new.vue';
import VideoInfo from 'src/pages/creative/video/video-info.vue';
import CreationFooter from 'src/components/creation-footer.vue';
import formHeader from 'src/components/common/form-header.vue';
import { useTikTokAuth } from './../media/tiktok-post/tiktokAuth';
import LeadFormListPopup from 'src/components/lead-ads-new/lead-form-list-popup.vue';
import { getInstantFormList as getInstantFormListApi } from './../../service/index';
import teaTracker from './../../tea-tracker';
import { TEA_EVENT } from './../../const/state/TeaNames';
import Cookies from 'js-cookie';
import store from './../../store/index';
import { SelfServeIdentityCreation, SelfServeIdentityDisplay } from '@ad/self-serve-sdk-vue';
import request from './../../utils/request/index';
import { cut2Square } from './../../utils/creativeUtil';
import identityStore from './../../store/modules/identity/index';
import { reportXFmp } from './../../plugin/perfMeasurePlugin';
import { useIdentityHooks, verifyIdentityStatus } from './../../hooks/global/useIdentityHooks';
import uploadVideoFailedComponent from '@/components/video-library/video-upload-over-limit.vue';
import { useObjectiveHooks } from './../../hooks/creation/objective/objectiveStatus';
const name = 'creative';
export default defineComponent({
  name,
  components: {
    VideoInfo,
    formHeader,
    TiktokPost,
    videoUpload,
    PopupChosen,
    HeaderStepNew,
    CreationFooter,
    CreativePreviewer,
    LeadFormListPopup,
    SelfServeIdentityCreation,
    SelfServeIdentityDisplay,
    uploadVideoFailedComponent,
  },
  setup() {
    const id = ref('');
    const { proxy: _this } = getCurrentInstance() as ComponentInternalInstance;
    const { currentObjectiveType } = useObjectiveHooks();
    const noVideo = ref(false);
    const noLead = ref(false);
    const creativeRef = ref(null);
    const creativeStates = useState();
    const showVideoUpload = ref(false);
    const showInstantFormPopup = ref(false);
    const instantForm = ref({} as InstantFormItem);
    const showCta = ref(false);
    const tiktokPostShow = ref(false);
    const urlInputError = ref(false);
    const videoInstance = ref();

    const {
      avatarIconUrl,
      ownedTikTokAccount,
      displayName,
      localDisplayName,
      avatarIcon,
      localAvatarIcon,
      fakeAccount,
      curIdentity,
      useTikTokIdentity,
      localAvatarIconUrl,
    } = useIdentityHooks();
    const handleVideoUploadShow = (show) => {
      showVideoUpload.value = show;
      show &&
        teaTracker.trackEvent(TEA_EVENT.USER_CHOOSE_TO_CREATE_NEW_VIDEO, {
          objective_type: currentObjectiveType.value,
        });
    };
    const handleVideoInstance = (vi, successCB = () => {}) => {
      videoInstance.value = vi;
      successCB();
    };
    const handleFocusReport = (): void => {
      teaTracker.trackEvent(TEA_EVENT.USER_ENTER_AD_TEXT, {
        objective_type: currentObjectiveType.value,
      });
    };
    const updateIdentityStore = (ifUpdateTikTokAccountUsage) => {
      if (identityStore?.state?.identity?.displayName?.value) {
        return;
      }
      if (fakeAccount.value.length > 0) {
        const latestUseFakeAccount = fakeAccount.value[0];
        identityStore.mutations.setLocalDisplayName(latestUseFakeAccount?.display_name);
        identityStore.mutations.setLocalAvatarIcon(latestUseFakeAccount?.avatar_icon);
      }
      identityStore.mutations.setCurIdentity(ownedTikTokAccount.value);

      const identityFormData = identityStore.getters.identityFormData.value;
      const identityInit = identityFormData.identityInit;
      const shouldUpdateTikTokAccountUsage = ifUpdateTikTokAccountUsage || !identityInit;
      if (shouldUpdateTikTokAccountUsage) {
        identityStore.mutations.setUseTikTokIdentity(!isEmpty(ownedTikTokAccount.value));
        if (isEmpty(ownedTikTokAccount.value) && fakeAccount.value.length > 0) {
          identityStore.mutations.setCurIdentity({
            identity_type: 1,
          });
          identityStore.mutations.setDisplayName(fakeAccount.value[0]?.display_name);
          identityStore.mutations.setAvatarIcon(fakeAccount.value[0]?.avatar_icon);
        }
        if (!isEmpty(ownedTikTokAccount.value)) {
          identityStore.mutations.setAvatarIcon(ownedTikTokAccount.value.avatar_icon);
          identityStore.mutations.setDisplayName(ownedTikTokAccount.value.display_name);
        }
      }
    };
    const authCallback = async () => {
      _this.$Loading.show();
      try {
        await identityStore.actions.getIdentityList();
        updateIdentityStore(true);
        const { identity_type, identity_id } = curIdentity.value;
        await identityStore.actions.getNativeMaterialList(identity_type, identity_id);
        tiktokPostShow.value = true;
      } catch (e) {
        console.log('login error');
      } finally {
        _this.$Loading.hide();
      }
    };
    const useCustomCreateAvatarProps = computed(() => {
      const aadvid = computed(() => store.state?.account?.accountInfo?.id || '');
      const headers = {
        'X-CSRFToken': Cookies.get('csrftoken'),
      };
      const action = `/api/v3/i18n/tools/upload_image/?aadvid=${aadvid.value}`;
      const pureAction = '/api/v3/i18n/tools/upload_image/';
      return {
        pureAction,
        headers,
        action,
      };
    });
    const handleChopAndUpload = async (e): Promise<void> => {
      const file = e.detail;
      const square = await cut2Square(file);
      const blobToFile = new File([square], file.name, { lastModified: file.lastModified });
      const formData = new FormData();
      formData.append('Filedata', blobToFile);
      const choppedImage = await request.post(useCustomCreateAvatarProps.value.pureAction, formData, {
        headers: useCustomCreateAvatarProps.value.headers,
      });
      creativeStates.handleCroppedImage(choppedImage?.data);
    };

    const handleTiktokPostPanel = (value, selectedVideo = false): any => {
      if (isEmpty(curIdentity.value)) {
        teaTracker.trackEvent(TEA_EVENT.USER_CLICK_LINK_TIKTOK_ACCOUNT);
        useTikTokAuth(async () => {
          await authCallback();
        });
        return;
      }
      if (value) {
        teaTracker.trackEvent(TEA_EVENT.USER_CLICK_TIKTOK_POST_BUTTON, {
          objective_type: adsCreative.getters.campaignFormData.value.objectiveType,
        });
        teaTracker.trackEvent(TEA_EVENT.DISPLAY_TIKTOK_PAGE);
      }
      tiktokPostShow.value = value;
      if (!value && selectedVideo) {
        try {
          creativeStates?.creationForm?.value?.validateField(
            'title',
            () => new Error('fastcreation_media_material_hint'),
          );
        } catch (e) {
          console.log(e);
        }
      }
    };
    const errorObj = error.value;
    const validate = (): Promise<any> =>
      new Promise<{
        valid: boolean;
        props?: Record<keyof typeof creativeStates.creative.value, { field: string; message: string }>;
      }>((resolve) => {
        creativeStates.creationForm.value.validate((ifValid, props) => {
          resolve({ valid: ifValid, props });
        });
      });

    const ifTikTokPost = computed(() => adsCreative.getters.ifTikTokVideo.value);
    const ctaLabel = computed(() => adsCreative.state.creative.curCtaLabel.value);
    const ctaOptionsByPop = computed(() =>
      TTCallToAction.map(({ id, key }) => ({
        value: id,
        label: i18n.t(key),
      })),
    );

    const values = computed(() => ({
      callToAction: creativeStates.creative.value.callToAction,
      title: creativeStates.creative.value.title,
      externalUrl: creativeStates.creative.value.externalUrl,
      identityData: {
        displayName: displayName.value,
        avatarIcon: avatarIcon.value,
      },
    }));
    const videoSelection = (videoInfo): any => {
      const allVideos = identityStore.getters.identityFormData.value.nativeVideoList.filter(
        (video) =>
          video.video_info.play_url === videoInfo.src.value &&
          video.video_info.cover_url === videoInfo.post.value,
      );
      adsCreative.mutations.setSelectedVideo(allVideos[0]);
      creativeStates.fakeIdentityObject.value = {
        avatarIcon: avatarIcon.value,
        displayName: displayName.value,
      };
      tiktokPostShow.value = false;
    };
    const handleAuthChange = (e, where, event): void => {
      teaTracker.trackEvent(TEA_EVENT.USER_CLICK_DISCLAIMER, {
        objective_type: currentObjectiveType.value,
      });
      if (where === 'link') {
        event?.stopPropagation(event);
      }
      adsCreative.mutations.setIsCreativeAuthorized(e);
    };
    const handleVideoRemove = (): void => {
      creativeStates.fakeIdentityObject.value = {
        avatarIcon: localAvatarIcon.value,
        displayName: localDisplayName.value,
      };
    };
    const handleVideoStopGenerate = (): void => {
      videoInstance.value?.stopVideoCreation();
    };
    const handleShowLeadForm = (): void => {
      creativeStates?.leadGenIframe?.value
        ? teaTracker.trackEvent(TEA_EVENT.USER_CREATE_NEW_FORM, {
          objective_type: currentObjectiveType.value,
        })
        : teaTracker.trackEvent(TEA_EVENT.USER_CLICK_DROPDOWN_LIST_LEAD_GEN, {
          objective_type: currentObjectiveType.value,
        });
      showInstantFormPopup.value = true;
    };
    const handleProfileSwitch = (): void => {
      if (ifTikTokPost.value) {
        return;
      }
      if (!ifTikTokPost.value && isEmpty(ownedTikTokAccount.value)) {
        useTikTokAuth(async () => {
          await authCallback();
        });
        return;
      }
      if (useTikTokIdentity.value) {
        teaTracker.trackEvent(TEA_EVENT.USER_SWITCH_TO_CUSTOM_ACCOUNT, {
          objective_type: currentObjectiveType.value,
        });
        identityStore.mutations.setDisplayName(ownedTikTokAccount.value.display_name);
        identityStore.mutations.setAvatarIcon(ownedTikTokAccount.value.avatar_icon);
        creativeStates.fakeIdentityObject.value = {
          avatarIcon: localAvatarIcon.value,
          displayName: localDisplayName.value,
        };
      } else {
        teaTracker.trackEvent(TEA_EVENT.USER_SWITCH_TO_TIKTOK_ACCOUNT, {
          objective_type: currentObjectiveType.value,
        });
        identityStore.mutations.setDisplayName(ownedTikTokAccount.value.display_name);
        identityStore.mutations.setAvatarIcon(ownedTikTokAccount.value.avatar_icon);
        identityStore.mutations.setCurIdentity(ownedTikTokAccount.value);
      }
      identityStore.mutations.setUseTikTokIdentity(
        !identityStore.getters.identityFormData.value.useTikTokIdentity,
      );
    };
    const handleNextStep = async (router, route): Promise<void> => {
      const { identity_type, identity_id } = curIdentity.value || {};
      // check if user selecting video library, or updated material with unavailable tiktok identity
      if (identity_type === IdentityType.TT_USER && useTikTokIdentity.value) {
        const ifAvailable = await verifyIdentityStatus(identity_type, identity_id);
        if (!ifAvailable) {
          _this.$toast(_this.$t('fastcreation_identity_invalid_desc'));
          return;
        }
      }
      noVideo.value = creativeStates.ifAtInitVideoStage.value;
      noLead.value =
        creativeStates.isLead.value && isEmpty(adsCreative.getters.creativeFormData.value.instantForm);
      const displayNameNotLegal = useTikTokIdentity.value
        ? false
        : localDisplayName.value?.length === 0 || localDisplayName.value?.length > 40;
      if (displayNameNotLegal) {
        creativeStates.displayNameInvalid.value = true;
      }
      const { valid } = await validate();
      if (!valid || noVideo.value || noLead.value || displayNameNotLegal) {
        creativeRef.value.scrollIntoView();
        return;
      }
      noVideo.value = false;
      _this.$Loading.show();
      await saveDraft();

      router.push({ name: 'audience', query: { ...route.query } });
      teaTracker.trackEvent(TEA_EVENT.CONTINUE, {
        objective_type: currentObjectiveType.value,
        page: 'ad',
      });
    };

    const handleShowCTA = () => {
      teaTracker.trackEvent(TEA_EVENT.USER_CLICK_CTA, {
        objective_type: currentObjectiveType.value,
      });
      showCta.value = true;
    };
    const handleUrlReport = () => {
      teaTracker.trackEvent(TEA_EVENT.USER_ENTER_URL);
    };
    const handleIdentityFocus = () => {
      teaTracker.trackEvent(TEA_EVENT.USER_UPDATE_PROFILE_NAME, {
        objective_type: currentObjectiveType.value,
      });
    };
    onMounted(async () => {
      reportXFmp();
      _this.$Loading.hide(); // hide from previous loading
      teaTracker.trackEvent(TEA_EVENT.SHOW_AD_DETAILS_PAGE, {
        source: 'new',
        objective_type: currentObjectiveType.value,
      });
      teaTracker.trackEvent(TEA_EVENT[`${creativeStates.objective.value}_SHOW`]);
      _this.$Loading.show();
      try {
        await identityStore.actions.getIdentityList();
        updateIdentityStore(false);
        if (!adsCreative.getters.creativeFormData.value.setFromDraft) {
          identityStore.mutations.setCurIdentity(ownedTikTokAccount.value);
        }
        identityStore.mutations.setIdentityStatus(true);
        creativeStates.fakeIdentityObject.value = {
          avatarIcon: avatarIcon.value,
          displayName: displayName.value,
        };
        // if (!isEmpty(curIdentity.value)) {
        //   const { identity_type, identity_id } = curIdentity.value;
        //
        //   // await identityStore.actions.getNativeMaterialList(identity_type, identity_id);
        // }
        if (creativeStates.isLead.value) {
          getInstantFormListApi({
            page: 1,
          }).then(({ data }) => {
            if (!data) {
              return;
            }
            const { page_list, pagination } = data;
            if (page_list.length) {
              adsCreative.mutations.setInstantForm(page_list.find((item) => item.preview_url));
            }
          });
        }
      } catch (e) {
        // 素材拉取失败展示empty页面，这里不需要额外处理
      } finally {
        _this.$Loading.hide();
      }
    });
    return {
      ...creativeStates,
      localAvatarIconUrl,
      localDisplayName,
      avatarIconUrl,
      displayName,
      noVideo,
      noLead,
      handleProfileSwitch,
      handleIdentityFocus,
      ctaLabel,
      handleShowCTA,
      handleUrlReport,
      handleAuthChange,
      tiktokPostShow,
      creativeRef,
      showCta,
      values,
      errorObj,
      ctaOptionsByPop,
      handleNextStep,
      name,
      handleVideoStopGenerate,
      handleVideoRemove,
      instantForm,
      showInstantFormPopup,
      videoSelection,
      showVideoUpload,
      urlInputError,
      handleVideoInstance,
      handleVideoUploadShow,
      handleTiktokPostPanel,
      ifTikTokPost,
      handleFocusReport,
      handleShowLeadForm,
      useTikTokIdentity,
      useCustomCreateAvatarProps,
      handleChopAndUpload,
    };
  },
});
